<onyx-icon
  name="tooltip-filled"
  [size]="size()"
  [tabIndex]="0"
  [onyxTooltip]="tooltip()"
  [onyxTooltipColor]="color()"
  [onyxTooltipShowArrow]="showArrow()"
  [onyxTooltipTextAlign]="textAlign()"
  [onyxTooltipDelay]="delay()"
  [onyxTooltipDisabled]="disabled()"
></onyx-icon>
